import React, { useEffect, useRef } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  IconButton,
} from "@mui/material";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import PersonIcon from "@mui/icons-material/Person";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import GlobalCard from "../../../../components/GlobalCardComponent";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useNavigate } from "react-router-dom";
import CustomCardWithBorder from "../../../../components/CustomCardWithBorder";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./demoslider.css";
import BlueSmallButton from "../../../../components/customButtons/BlueSmallButton";
export default function ViewUpcommingDemoCard({ demoData }) {
  const navigate = useNavigate();
  const paginationRef = useRef(null);
  const swiperRef = useRef(null); // ✅ Define swiperRef

  useEffect(() => {
    const handleResize = () => swiperRef.current?.swiper?.update();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigateToZoomLink = (link) => {
    const zoomLink = link;

    window.open(zoomLink, "_blank");
  };
  return (
    <>
      <Grid container>
        <Grid item xs={6} md={9}>
          <Typography
            fontSize="20px"
            color="#000000"
            sx={{ fontWeight: 600, fontFamily: "Inter" }}
          >
           Upcoming Demos
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          display="flex"
          alignItems="center"
          justifyContent="end"
          gap={1}
          style={{ cursor: "pointer" }}
        >
          <Typography
            fontSize="12px"
            color="#572575"
            sx={{ fontWeight: 400, fontFamily: "Inter" }}
            onClick={() => navigate("/test-prep/demos")}
          >
            View All
          </Typography>
          <KeyboardArrowRightIcon
            style={{ color: "#572575", fontSize: "1rem" }}
            onClick={() => navigate("/test-prep/demos")}
          />
        </Grid>

        <Box
          mt={1}
          sx={{
            width: "100%",
            maxWidth: {
              xs: 375,
              sm: 500,
              md: 700,
              lg: 900,
              xl: 1200,
            },
            minHeight: { xs: "100px", md: "100px" },

            position: "relative",
          }}
        >
          <Box width="100%">
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={20}
              slidesPerView={1}
              pagination={{ clickable: true, el: paginationRef.current }}
              onBeforeInit={(swiper) => {
                swiper.params.pagination.el = paginationRef.current;
              }}
              autoplay={{
                delay: 3000,
                // disableOnInteraction: false,
              }}
              loop
              style={{
                padding: "0 5px 7px", // ← Add horizontal padding
                // ← Allow shadows/rounded corners to be visible
              }}
              observer={true}
              observeParents={true}
              resizeObserver={true}
              breakpoints={{
                // small screens (mobile)
                0: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                // tablets
                600: {
                  slidesPerView: 1,
                  spaceBetween: 15,
                },
                // small desktops
                900: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                // large desktops
                1200: {
                  slidesPerView: 1,
                  spaceBetween: 25,
                },
              }}
            >
              {demoData?.map((data, index) => (
                <SwiperSlide key={index}>
                  <Grid item xs={12} mt={2}>
                    <Card
                      sx={{
                        p: 2,
                        borderRadius: "22px",
                        boxShadow: "0px 0px 3.81px 0px rgba(0, 0, 0, 0.25)",
                        background:
                          "linear-gradient(180deg, #FFFFFF 0%, #FDF3FD 100%)",
                      }}
                    >
                      {/* Header Row */}
                      <Grid container spacing={2}>
                        <Grid
                          item
                          xs={12}
                          container
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Typography
                            color="#313439"
                            fontFamily="Inter"
                            fontSize="16px"
                            lineHeight="100%"
                            letterSpacing="0px"
                            sx={{ fontWeight: 600 }}
                          >
                            {data?.class_id?.name}
                          </Typography>
                        </Grid>

                        {/* Details */}
                        <Grid item xs={12} mt={1}>
                          <Grid container spacing={2}>
                            {/* Instructor */}
                            <Grid item xs={12}>
                              <Box display="flex" alignItems="center" gap={1}>
                                <Box width={24}>
                                  <img
                                    src="/newdashboard/DashboardClassAndDemo/Group 1171282736.png"
                                    alt="Instructor"
                                  />
                                </Box>
                                <Typography
                                  color="#161719"
                                  fontFamily="Inter"
                                  fontSize="12px"
                                  lineHeight="100%"
                                  letterSpacing="0px"
                                  sx={{ fontWeight: 500 }}
                                >
                                  {data?.trainer_id?.first_name} {data?.trainer_id?.last_name}
                                </Typography>
                              </Box>
                            </Grid>

                            {/* Mode */}
                            <Grid item xs={12}>
                              <Box display="flex" alignItems="center" gap={1}>
                                <Box width={24}>
                                  <img
                                    src="/newdashboard/DashboardClassAndDemo/Group 1171282735 (3).png"
                                    alt="Mode"
                                  />
                                </Box>
                                <Typography
                                  color="#161719"
                                  fontFamily="Inter"
                                  fontSize="12px"
                                  lineHeight="100%"
                                  letterSpacing="0px"
                                  sx={{ fontWeight: 500 }}
                                >
                                  {data?.delivery_mode
                                    ? data.delivery_mode
                                        .charAt(0)
                                        .toUpperCase() +
                                      data.delivery_mode.slice(1)
                                    : ""}
                                </Typography>
                              </Box>
                            </Grid>

                            {/* Date & Time */}
                            <Grid item xs={12}>
                              <Box display="flex" alignItems="center" gap={1}>
                                <Box width={24}>
                                  <img
                                    src="/newdashboard/DashboardClassAndDemo/Group 1171282735 (4).png"
                                    alt="Date & Time"
                                  />
                                </Box>
                                <Typography
                                  color="#161719"
                                  fontFamily="Inter"
                                  fontSize="12px"
                                  lineHeight="100%"
                                  letterSpacing="0px"
                                  sx={{ fontWeight: 500 }}
                                >
                                  {data?.slot} , {data?.available_demo_date}
                                </Typography>
                              </Box>
                            </Grid>

                            {data?.delivery_mode === "offline" && (
                              <Grid item xs={12}>
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Box width={24} flexShrink={0}>
                                    <img
                                      src="/newdashboard/DashboardClassAndDemo/Group 1171285184.png"
                                      alt="Date & Time"
                                    />
                                  </Box>
                                  <Typography
                                    color="#161719"
                                    fontFamily="Inter"
                                    fontSize="13px"
                                    lineHeight="1.4"
                                    letterSpacing="0px"
                                    sx={{ fontWeight: 500 }}
                                  >
                                    {data?.class_data?.branch_id?.address}
                                  </Typography>
                                </Box>
                              </Grid>
                            )}

                            {/* Join Demo */}
                            {data?.delivery_mode === "online" && (
                              <Grid item xs={12}>
                                <BlueSmallButton
                                  buttonTitle="Join Demo"
                                  width="100%"
                                  onClick={(e) => {
                                    e.preventDefault(); // prevent any default navigation
                                    navigateToZoomLink(
                                      data?.class_data?.zoom_link
                                    );
                                  }}
                                />
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
          {/* Custom pagination below the images */}
          <Box sx={{ width: "100%", position: "relative" }}>
            <Box
              ref={paginationRef}
              className="custom-pagination-demo"
              sx={{
                position: "absolute",
                bottom: 0,
                left: "50% !important",
                transform: "translateX(-50%)",
              }}
            />
          </Box>
        </Box>
      </Grid>
    </>
  );
}
